/* src/app/shared/contract/contract-item/contract-natio-nego/natio-nego-managing-dialog/natio-nego-managing-dialog.component.scss */
.mat-title,
.add-category-bloc-container > span:first-child {
  color: #001A33;
}
.container {
  max-height: calc(100dvh - 120px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 1245px;
  max-width: calc(100vw - 32px - 30px - 30px);
  margin: 0;
  border: red 10px;
}
.container > :not(.dialog-form-content) {
  flex-shrink: 0;
}
.dialog-form-content {
  position: relative;
  flex-shrink: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.dialog-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cond-container {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  gap: 20px;
}
.cond-container.multiple-include-groups {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
@media (max-width: 1000px) {
  .cond-container.multiple-include-groups {
    grid-template-columns: minmax(0, 1fr);
  }
}
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.85);
}
.title-container {
  justify-content: flex-start;
  font: 700 16px FranceTV Brown;
  margin-bottom: 10px;
  border: red 10px;
}
.bloc-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.red-title {
  font: 400 14px FranceTV Brown;
  color: #F03C64;
}
.condition-summary-table-container {
  background-color: #FFF;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #DFEBF7;
}
.condition-summary-scroll {
  --condition-summary-header-height: 36px;
  --condition-summary-row-height: 32px;
  max-height: calc(var(--condition-summary-header-height) + 6 * var(--condition-summary-row-height));
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
.condition-summary-table {
  width: 100%;
  table-layout: fixed;
}
.condition-summary-table .mat-mdc-header-row {
  height: var(--condition-summary-header-height);
}
.condition-summary-table .mat-mdc-row {
  height: var(--condition-summary-row-height);
}
.condition-summary-table .mat-mdc-header-cell,
.condition-summary-table .mat-mdc-cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.condition-summary-table .mat-column-category-number-1,
.condition-summary-table .mat-column-category-number-4 {
  width: 80px;
}
.condition-summary-table .mat-column-category-number-2 {
  width: 112px;
}
.condition-summary-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rate {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.add-category-bloc-container {
  display: flex;
  align-items: center;
  gap: 10px;
  font: 400 14px FranceTV Brown;
  margin-right: 5px;
}
.add-category-bloc-container .type-icon {
  height: 16px;
}
.add-category-bloc-container .type-icon:hover {
  cursor: pointer;
}
.add-category-bloc-container .add-condition-button-wrapper {
  display: inline-flex;
}
.add-category-bloc-container .add-condition-button:disabled {
  pointer-events: none;
}
.add-category-bloc-container .add-condition-button:disabled .type-icon {
  opacity: 0.4;
  cursor: default;
}
.button-edit {
  justify-content: flex-end;
  display: inline-flex;
}
.saving-content {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 260px;
  width: 100%;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 25px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
/*# sourceMappingURL=natio-nego-managing-dialog.component.css.map */
